<template>
    <div >
      <Navbar id="navbar" />
      <div class="content-wrapper">
        <div class="content">
          <h5>Editeur</h5>
           <p><strong>Directeur de la publication :</strong> Jean-Emmanuel RHIE<br>
            com@fibourse.com <br> FIBOURSE, société par actions simplifiée au capital de 10 000,00 Euro</p>
            <p><strong>Siège social</strong> <br>
                11 Place Georges Clémenceau 13420 GEMENOS <br> SIREN :    979 491 933 <br> Numéro de TVA: FR06979491933 <br> ORIAS: 23007659 https://www.orias.fr <br> Membre de COURTENSIA dans la catégorie COBSP</p> <br>
          <h5>Hébergeur du site</h5> 
          <p>ComAITe (Communication and All Internet Technologies) SARL au capital de 10 000,00 Euros</p>     
          <p><strong>Siège social</strong><br>2, place Alexandre FARNESE 84000 AVIGNON <br>SIREN  811 775 550 RCS AVIGNON <br>N° de TVA intracommunautaire : FR42 811775550 </p>
        
      </div>
      </div>
      <Footer id="footer" />
    </div>
  </template>
  
  <style scoped>
  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  .content-wrapper {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20%; 
    padding-right: 20%; 
    padding-top: 40px;
    padding-bottom: 40px;
    box-sizing: border-box;
    overflow: auto;
    width:1322.31px important !important ;
  }
  
  .content {
    background-color: #ffffff;
    max-width: 800px; /* Adjust as needed */
    width: 100%;
    overflow: auto;
  }
  
  #footer {
    width: 100%;
    bottom: 0;
    position: fixed;
  }
  
  h5 {
    font-family: Space Grotesk ;
    font-weight: 700;
    font-size: 40px;
    color: #000000BF;
    line-height:40px;
  }
  h6 {
    font-family: Space Grotesk ;
    font-weight: 500;
    font-size: 22px;
    color: #000000BF;
    line-height:40px;
  }
  
  p {
    font-family: Inter ;
    font-weight: 400;
    font-size: 16px;
    line-height:25.6px;
  }
  
  </style>
  
    
  <script>
  
  import Footer  from '@/components/footer.vue';
  import Navbar from './navbar/navbar.vue';
  
  export default {
      name: 'Mentions',
      components: {
          Footer,
          Navbar
      },
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  
  <style scoped>
  /* Add your styles here */
  </style>
  